import { FadeUp, Eyebrow } from "@/components/reveal";

const SERVICES = [
    {
        n: "01",
        title: "Government & innovation strategy",
        desc: "Working with governments, port authorities and innovation hubs on strategy, engagement and investment for the next generation of infrastructure.",
    },
    {
        n: "02",
        title: "Strategic partnerships",
        desc: "Building the long-term partnerships that turn strategy into real projects — connecting institutions, operators, technology and capital.",
    },
    {
        n: "03",
        title: "Market insight",
        desc: "Advising institutions on the trends and opportunities reshaping global infrastructure, from trade routes to the energy transition.",
    },
];

const WhatWeDo = () => (
    <section id="what-we-do" data-testid="what-we-do-section" className="py-24 lg:py-32">
        <div className="container-x">
            <div className="grid gap-10 lg:grid-cols-12">
                <div className="lg:col-span-7">
                    <FadeUp>
                        <Eyebrow>What we do</Eyebrow>
                    </FadeUp>
                    <FadeUp delay={0.1}>
                        <h2 className="mt-6 font-serif text-4xl tracking-tight sm:text-5xl lg:text-6xl">
                            Strategy that becomes{" "}
                            <em className="italic text-olive">projects</em>
                        </h2>
                    </FadeUp>
                </div>
                <div className="lg:col-span-4 lg:col-start-9">
                    <FadeUp delay={0.2}>
                        <p className="text-lg leading-relaxed text-inksoft">
                            Strategy for the institutions that shape infrastructure,
                            and partnerships that turn that strategy into real
                            projects.
                        </p>
                    </FadeUp>
                </div>
            </div>

            <div className="mt-16 grid gap-10 md:grid-cols-3 lg:gap-12">
                {SERVICES.map((s, i) => (
                    <FadeUp key={s.n} delay={i * 0.1} className="h-full">
                        <div
                            data-testid={`service-card-${s.n}`}
                            className="group flex h-full flex-col border-t-2 border-ink/15 pt-7 transition-colors duration-500 hover:border-olive"
                        >
                            <span className="font-mono text-sm tracking-[0.2em] text-inkmut transition-colors duration-500 group-hover:text-olive">
                                {s.n}
                            </span>
                            <h3 className="mt-6 font-serif text-2xl leading-snug text-ink">
                                {s.title}
                            </h3>
                            <p className="mt-4 text-sm leading-relaxed text-inksoft">
                                {s.desc}
                            </p>
                        </div>
                    </FadeUp>
                ))}
            </div>
        </div>
    </section>
);

export default WhatWeDo;
